import type {
  CompositionV3Filters,
  TransitionsV3Filters,
} from '@revelio/data-access';

import { type Filter, FilterType } from '../types/filters';

type FilterKey = keyof CompositionV3Filters | keyof TransitionsV3Filters;

export const getV3ListFilter = ({
  filter,
  key,
}: {
  filter: Filter;
  key: FilterKey;
}): CompositionV3Filters | TransitionsV3Filters => {
  if (filter.type !== FilterType.LIST) return {};
  return {
    [key]: filter.selections.map((selection) => parseInt(selection.id, 10)),
  };
};
